import React from 'react'
import { Link } from 'react-router-dom'

const Navbar = () => {
  return (
    <div className="flex justify-between items-center z-[999999] pt-[15px] md:pt-[47px]">
      <div className="w-[80px] sm:w-[130px]">
        <img src="/img/webpImg/Tbd-Logo.webp" alt="Logo" />
      </div>

      <Link
        to={
          "https://play.google.com/store/apps/details?id=com.the_best_dealsApp"
        }
        className="bg-[#7E54F2] w-fit text-[#FFF] text-center text-xs sm:text-sm font-medium leading-normal tracking-[0.334px] uppercase sm:px-[20px] px-[14px] py-[9px] sm:py-[13px] rounded-[42px] flex items-center justify-center cursor-pointer"
      >
        Install App
      </Link>
    </div>
  );
}

export default Navbar
